import { createActions } from 'redux-actions'
import { Paths } from 'utils/paths'

const LearnGuides = createActions({}, 'GET_LEARN_GUIDES_FEATURED_PENDING')

LearnGuides.getFeatured = () => {
  return (dispatch) => {
    const url = Paths.api_learn_guides_featured()

    dispatch(LearnGuides.getLearnGuidesFeaturedPending())

    return dispatch({
      type: 'GET_LEARN_GUIDES_FEATURED',
      payload: fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => response.json())
    })
  }
}

export default LearnGuides
